import { render, staticRenderFns } from "./chat-box-user.vue?vue&type=template&id=9f1ebc4c&scoped=true"
import script from "./chat-box-user.vue?vue&type=script&lang=js"
export * from "./chat-box-user.vue?vue&type=script&lang=js"
import style0 from "./chat-box-user.vue?vue&type=style&index=0&id=9f1ebc4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1ebc4c",
  null
  
)

export default component.exports